import VerificationModal from "./verification-modal.component";

export default VerificationModal;
